import { useCurrentUser } from 'hooks/auth';

export const useCompanyRegion = () => {
  const { data } = useCurrentUser();
  const region = data?.currentCompanyUser?.company?.region;

  return region;
};

export const useIsUsCompany = () => {
  const region = useCompanyRegion();

  return region === 'US';
};

export const useIsEuropeCompany = () => {
  const region = useCompanyRegion();

  return region === 'EUROPE';
};
